export function delay(time:number):Promise<any> {
	return new Promise(r => setTimeout(()=>r(), time));
}


// WEBPACK FOOTER //
// ./node_modules/typeQuery/utils/delay.ts